// Per-concept-page links to each framework's own tutorial for that same
// topic, shown in the page's "Tutorials:" panel (see pageComponent.js).
// enabled:false means that framework's tutorial hasn't been written yet —
// flip it to true (and fix up `to` if the eventual slug differs) once it
// exists, same convention as the `enabled` flag on landing page tiles.
const FRAMEWORK_TUTORIAL_LINKS = {
    'multiclass-classification': [
        {label: 'ML.NET', to: '/machine-learning/tutorials/mlnet/interactive-iris-classification', enabled: true},
        {label: 'PyTorch', to: '/machine-learning/tutorials/pytorch/multiclass-classification', enabled: false},
        {label: 'TensorFlow', to: '/machine-learning/tutorials/tensorflow/multiclass-classification', enabled: false},
        {label: 'Scikit-Learn', to: '/machine-learning/tutorials/scikit-learn/multiclass-classification', enabled: false},
        {label: 'SciPy', to: '/machine-learning/tutorials/scipy/multiclass-classification', enabled: false},
    ],
    'unsupervised-learning-simulation': [
        {label: 'ML.NET', to: '/machine-learning/tutorials/mlnet/mlnet-simulation', enabled: true},
        {label: 'PyTorch', to: '/machine-learning/tutorials/pytorch/simulation', enabled: true},
        {label: 'TensorFlow', to: '/machine-learning/tutorials/tensorflow/simulation', enabled: true},
        {label: 'Scikit-Learn', to: '/machine-learning/tutorials/scikit-learn/simulation', enabled: true},
        {label: 'SciPy', to: '/machine-learning/tutorials/scipy/simulation', enabled: true},
    ],
    // SciPy links to its feature-engineering tutorial's SVD section rather
    // than a dedicated page, since that's where its real content lives.
    'dimensionality-reduction': [
        {label: 'ML.NET', to: '/machine-learning/tutorials/mlnet/mlnet-dimensionality-reduction', enabled: true},
        {label: 'PyTorch', to: '/machine-learning/tutorials/pytorch/dimensionality-reduction', enabled: true},
        {label: 'TensorFlow', to: '/machine-learning/tutorials/tensorflow/dimensionality-reduction', enabled: true},
        {label: 'Scikit-Learn', to: '/machine-learning/tutorials/scikit-learn/dimensionality-reduction', enabled: true},
        {label: 'SciPy', to: '/machine-learning/tutorials/scipy/feature-engineering', enabled: true},
    ],
};

export function getFrameworkTutorialLinks(slug) {
    return FRAMEWORK_TUTORIAL_LINKS[slug] || [];
}

export default FRAMEWORK_TUTORIAL_LINKS;
